import styles from './errorpage.module.scss';

export default function ErrorPage() {
    return (
        <div className={styles.errorContainer}>
            <h1 className={styles.errorHeader}>Oi sann... noe gikk galt</h1>
            <p className={styles.errorText}>Våre digitale løypebaser er på saken. Gå til forsiden og prøv igjen.</p>
            <p className={styles.errorText}>
                Oppstår problemet igjen, ta kontakt på <a href="mailto:post@skiforeningen.no">post@skiforeningen.no</a>
            </p>
            <a className={styles.link} href={'https://www.skiforeningen.no/'}>
                Gå til forsiden
            </a>
        </div>
    );
}
